var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { UIComponent, customPropTypes, childrenExist, createShorthandFactory, commonPropTypes, } from '../../lib';
import Text from '../Text/Text';
import Input from '../Input/Input';
import Slot from '../Slot/Slot';
/**
 * A field is a form element containing a label and an input.
 */
var FormField = /** @class */ (function (_super) {
    __extends(FormField, _super);
    function FormField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldControlAppearFirst = function () {
            var type = _this.props.type;
            return type && (type === 'checkbox' || type === 'radio');
        };
        return _this;
    }
    FormField.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, accessibility = _a.accessibility, variables = _a.variables, styles = _a.styles, rest = _a.rest;
        var _b = this.props, children = _b.children, control = _b.control, id = _b.id, label = _b.label, message = _b.message, name = _b.name, required = _b.required, type = _b.type;
        var labelElement = Text.create(label, {
            defaultProps: {
                as: 'label',
                htmlFor: id,
                styles: styles.label,
            },
        });
        var messageElement = Text.create(message, {
            defaultProps: {
                styles: styles.message,
            },
        });
        var controlElement = Slot.create(control || {}, {
            defaultProps: { required: required, id: id, name: name, type: type, styles: styles.control },
        });
        var content = (React.createElement(React.Fragment, null,
            this.shouldControlAppearFirst() && controlElement,
            labelElement,
            !this.shouldControlAppearFirst() && controlElement,
            messageElement));
        return (React.createElement(ElementType, __assign({ className: classes.root }, rest), childrenExist(children) ? children : content));
    };
    FormField.displayName = 'FormField';
    FormField.className = 'ui-form__field';
    FormField.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { control: customPropTypes.itemShorthand, id: PropTypes.string, inline: PropTypes.bool, label: customPropTypes.itemShorthand, message: customPropTypes.itemShorthand, name: PropTypes.string, required: PropTypes.bool, type: PropTypes.string });
    FormField.defaultProps = {
        as: 'div',
        control: { as: Input },
    };
    return FormField;
}(UIComponent));
FormField.create = createShorthandFactory(FormField, 'label');
export default FormField;
